export default __webpack_public_path__ + "static/Raft-Event-Rules-e3d9f4fc5e69d4a46c6365c9b4a8f4ec.pdf";